export default import.meta.ROLLUP_FILE_URL_qSGrrLEtyxF3ktxn6$da_Q